module.exports = __webpack_public_path__ + "img/royal hospitals indoor shoot-236.a3eae7df.webp";